import React from 'react'
import { ConsultaTicketContextType } from './ConsultaTicketContextType'

const ConsultaTicketContext = React.createContext<ConsultaTicketContextType|null>(null)

export default ConsultaTicketContext